<div class="mt-5 centered">
    <!-- <app-pull-to-refresh (onPull)="reloadList()" [refresh]="isInProgress"> -->
        <ul class="list-group">

            <app-tra-paginator (reloadRequested)="reloadList()"></app-tra-paginator>
            <app-tra-filter (reloadRequested)="reloadList()"></app-tra-filter>

            <div class="input-group mt-3">
                <button type="button" class="btn btn-outline-success"
                        (click)="exportService.exportXLSX(travels_list)">
                    <i class="fas fa-file-excel"></i></button>
                <input type="text" class="form-control" aria-label="filtro" disabled
                       [ngModel]="'Export dei viaggi in xls'">
            </div>

            <div *ngIf="travels_list?.length == 0" style="display: inline-flex; width: 100%;" class="mt-3 mb-1">

                <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-warning"
                    [style.width]="'100%'">
                    Lista vuota. {{authService.is_admin() ?
                    'Non sono stati registrate viaggi per le autovetture appartenenti ' +
                    'ai parchi mezzi a te assegnati. Verifica di avere dei parchi mezzi assegnati.' :
                    'Non hai effettuato ancora nessun viaggio.'}}
                </li>
            </div>

            <div *ngFor="let travel of travels_list" style="display: inline-flex; width: 100%;" class="mt-3 mb-1">

                <li class="list-group-item"
                    [style.width]="authService.is_admin() && travel.travelRequested()
                    && ((!travel.travelApproved() && travel.status.id == 1) ||
                    (travel.travelApproved() && !travel.travelEnded() && travel.status.id == 3) )   ? '85%' : '85%'"
                    [class.list-group-item-success]='travel.status.id == 3 && travel.travelEnded()'
                    [class.list-group-item-pending]='travel.status.id == 3 && !travel.travelEnded()'
                    [class.list-group-item-danger]='travel.status.id == 2'
                    [class.list-group-item-alert]='travel.status.id == 1 && travel.travelRequested() &&
                    !travel.travelApproved()'>
                    <span style="float: right;" *ngIf="travel.travelStarted() && !travel.travelEnded()"><i><strong>
                        in corso ...
                    </strong></i> </span>
                    <span class="far fa-file-pdf fa-2x" style="cursor: pointer;float: right;" (click)="exportPDF(travel)"
                          *ngIf="travel.status.id == 3 && travel.travelEnded() && travel.vehicle.park.type_id != 1"></span>
                    <span class="far fa-file-pdf fa-2x" style="cursor: pointer;float: right;" (click)="exportPDFMilitare(travel)"
                        *ngIf="travel.status.id == 3 && travel.travelEnded() && travel.vehicle.park.type_id == 1"></span>
                    <div class="w-100 justify-content-between" (click)="travel.is_expanded = !travel.is_expanded">
                        <h6 class="mb-1">
                            <span *ngIf="!dom_elements.small_screen" class="oi "
                                  [class.oi-check]='travel.status.id == 3'
                                  [class.oi-ban]='travel.status.id == 2'
                                  [class.oi-clock]='travel.status.id == 1'></span>
                            <strong>{{ travel.user.name }} {{ travel.user.surname }}</strong><br>
                            <strong>#{{ travel.id }}</strong>
                            <!--<span class="fa " (click)="travel.is_expanded = !travel.is_expanded"
                            [class.fa-chevron-up]='travel.is_expanded'
                            [class.fa-chevron-down]='!travel.is_expanded'></span> -->

                        </h6>
                        <strong>Parco:</strong>
                        <p style="word-wrap: break-word;">{{ travel.trv_prk_name }}</p>
                        <br>

                        <strong>Motivazione:</strong>
                        <div *ngIf="exportService.determineMotivationOther(travel) && exportService.determineMotivationOther(travel).length > 100;
                        then longMotivation else shortMotivation">
                        </div>
                        <ng-template #longMotivation>
                            <button type="button" class="btn btn-link"
                                    (click)="$event.stopPropagation(); travel.motivationExpanded =
                                    !travel.motivationExpanded">
                                {{travel.motivationExpanded ? 'collassa' : 'espandi' }}
                            </button>
                            <div>
                                <p style="word-wrap: break-word;">{{travel.motivationExpanded ? exportService.determineMotivationOther(travel) :
                                exportService.determineMotivationOther(travel).substring(0,10)+'...'}} </p></div>
                        </ng-template>
                        <ng-template #shortMotivation>
                            <p style="word-wrap: break-word;">{{exportService.determineMotivationOther(travel)}}</p>
                        </ng-template>
                        <br>

                        <div *ngIf="routeExists(travel)">
                            <strong>Itinerario<span *ngIf="travel.route[0].ar"> andata-ritorno</span></strong>
                            <div *ngFor="let route of travel.route">
                                <p>Da {{ route.da }} - A {{ route.a }}</p>
                                <hr>
                            </div>
                        </div>
                        <br>

                        <strong>Persone Trasportate:</strong>
                        <div *ngIf="travel.passengers && travel.passengers.length > 100;
                        then longDrivers else shortDrivers">
                        </div>
                        <ng-template #longDrivers>
                            <button type="button" class="btn btn-link"
                                    (click)="$event.stopPropagation(); travel.o_driversExpanded  =
                                    !travel.o_driversExpanded ">{{travel.o_driversExpanded  ? 'collassa' : 'espandi' }}
                            </button>
                            <div>
                                <p style="word-wrap: break-word;"> {{travel.o_driversExpanded ? travel.passengers :
                                travel.passengers.substring(0,10)+'...'}}</p></div>
                        </ng-template>
                        <ng-template #shortDrivers>
                            <p style="word-wrap: break-word;">{{travel.passengers}}</p>
                        </ng-template>
                        <br>


                        <strong>Creata in data:</strong> {{dateHandler.formatDateClassic(travel.created_at)}} :
                        {{dateHandler.formatTimeClassic(travel.created_at)}}<br>
                        <strong>Richiesta da:</strong> {{dateHandler.formatDateClassic(travel.required_from)}} :
                        {{dateHandler.formatTimeClassic(travel.required_from)}}<br>
                        <strong>Richiesta a:</strong> {{dateHandler.formatDateClassic(travel.required_to)}} :
                        {{dateHandler.formatTimeClassic(travel.required_to)}}<br>


                        <div *ngIf="travel.is_expanded">
                            <div *ngIf="travel.travelPending()">
                                <!-- viaggio da gestire, effettuata solo la richiesta -->
                                <h6>
                                    Attenzione, questa richiesta di viaggio deve ancora essere gestita!
                                </h6>
                            </div>
                            <div *ngIf="travel.travelRefuesed()">
                                <strong>Chiuso in data:</strong> {{dateHandler.formatDateClassic(travel.ended_at)}}
                                :{{dateHandler.formatTimeClassic(travel.ended_at)}}<br>
                                <div *ngIf="travel.travelHandled()">
                                    <!-- viaggio rifiutato da amministratore -->
                                    <h6>
                                        Attenzione, questo viaggio è stato
                                        rifiutato dall'amministratore del parco mezzi
                                    </h6>
                                </div>

                                <div *ngIf="!travel.travelHandled()">
                                    <!-- richiesta cancellata da utente -->
                                    <h6>
                                        Attenzione, questo viaggio è stato cancellato dall'utente
                                    </h6>
                                </div>
                            </div>

                            <div *ngIf="travel.travelApproved()">

                                <br>
                                <strong>Targa: </strong> {{ travel.vehicle.plate }} <br>
                                <strong>Marca: </strong> {{ travel.vehicle.model.brand.name }} <br>
                                <strong>Modello: </strong> {{ travel.vehicle.model.name }} <br>
                                <strong>Classe: </strong> {{ travel.vehicle.type.name }} <br>
                                <strong>Superclasse: </strong> {{ travel.vehicle.type.supertype.name }} <br>
                                <br>

                                <div *ngIf="travel.travelStarted()">
                                    <!-- richiesta approvata ed in corso -->
                                    <strong>Foglio creato in data:</strong>
                                    {{dateHandler.formatDateClassic(travel.started_at)}}
                                    :{{dateHandler.formatTimeClassic(travel.started_at)}}<br>
                                    <strong>Kilometri iniziali: </strong> {{ travel.start_kilometers }} <br>

                                    <br>
                                    <a (click)="viewRefillsForTravel(travel)" style="cursor: pointer;"><strong>Rifornimenti: </strong>
                                        {{travel.refills_counted}} </a><br>
                                    <br>
                                    <strong>Prime Segnalazioni: </strong> {{ travel.first_reporting }} <br>
                                    <br>


                                    <div *ngIf="travel.travelEnded()">
                                        <!-- richiesta approvata e chiusa -->
                                        <strong>Foglio chiuso in data:</strong>
                                        {{dateHandler.formatDateClassic(travel.ended_at)}}
                                        :{{dateHandler.formatTimeClassic(travel.ended_at)}}<br>
                                        <strong>Kilometri finali: </strong> {{ travel.end_kilometers }} <br>
                                        <strong>Livello carburante: </strong>
                                        {{travel.fuel_level == 1 ? '&#48;' :   ''}}
                                        {{travel.fuel_level == 2 ? '&#188;' :  ''}}
                                        {{travel.fuel_level == 3 ? '&#189;' :  ''}}
                                        {{travel.fuel_level == 4 ? '&#190;' :  ''}}
                                        {{travel.fuel_level == 5 ? '&#49;' :   ''}}
                                        <br>
                                        <strong>Segnalazioni: </strong>
                                        <div
                                                *ngIf="travel.reporting && travel.reporting.length > 100;
                                                then longReporting else shortReporting">
                                        </div>
                                        <ng-template #longReporting>
                                            <button type="button" class="btn btn-link"
                                                    (click)="$event.stopPropagation(); travel.reportingExpanded =
                                                    !travel.reportingExpanded">{{travel.reportingExpanded ?
                                                'collassa' : 'espandi' }}</button>
                                            <div style="word-wrap: break-word;">
                                                {{travel.reportingExpanded ? travel.reporting :
                                                travel.reporting.substring(0,10)+'...'}} </div>
                                        </ng-template>
                                        <ng-template #shortReporting>
                                            {{travel.reporting}}
                                        </ng-template>

                                        <h6>
                                            <div
                                                    *ngIf="(!!travel.start_kilometers ||
                                                    travel.start_kilometers === '0') &&
                                                    (!!travel.end_kilometers ||
                                                    travel.end_kilometers === '0'); then ok else ko">
                                            </div>

                                            <ng-template #ok>
                                                Questo viaggio è terminato regolarmente
                                            </ng-template>
                                            <ng-template #ko>
                                                Questo viaggio è stato terminato dall'amministratore
                                            </ng-template>

                                        </h6>
                                    </div>
                                    <div *ngIf="travel.travelStarted() && !travel.travelEnded()">
                                        <h6>
                                            Attenzione, questo viaggio è in corso
                                        </h6>
                                    </div>

                                </div>
                                <div *ngIf="!travel.travelStarted()">
                                    <!-- richiesta approvata da far partire -->
                                    <h6>
                                        Attenzione, questo viaggio è stato approvato.
                                        L'utente non ha però ancora compilato il foglio di
                                        marcia.
                                    </h6>
                                </div>

                            </div>
                        </div>

                    </div>
                </li>

                <!-- PLANCIA BOTTONI DESTRA -->
                <div style="width:15%; display:grid;">
                    <!-- travel type 0 for USER | 1 for ADMIN -->
                    <!-- UTENTE ******************************************** -->
                    <ng-container  *ngIf="!travel.type">

                        <!-- CANCELLA RICHIESTA VIAGGIO -->
                        <ng-container *ngIf="travel.travelPending()">
                            <button type="button" class="btn btn-outline-danger"
                                    (click)="cancelTravelRequest(travel)"
                                    tooltip="Annulla richiesta di viaggio" placement="right">
                                <span class="oi oi-circle-x"></span>
                            </button>
                        </ng-container>

                        <!-- COMPILA FOGLIO DI Marcia-->
                        <ng-container *ngIf="travel.travelApproved() &&
                        !travel.travelStarted() && !travel.travelEnded()">
                            <button type="button" class="btn btn-outline-classic" (click)="compileWarrant(travel)"
                                    tooltip="Compila il foglio di marcia" placement="right">
                                <span class="oi oi-book"></span>
                            </button>
                        </ng-container>

                        <!-- VIAGGIO IN CORSO -->
                        <ng-container *ngIf="travel.travelApproved() &&
                        travel.travelStarted() && !travel.travelEnded()">

                            <button type="button" class="btn btn-outline-alert" (click)="insertRefills(travel)"
                                    tooltip="Inserisci rifornimento" placement="right">
                                <i class="fas fa-gas-pump"></i>
                            </button>

                            <button type="button" class="btn btn-outline-alert" (click)="getVehicleDocument(travel)"
                                    tooltip="Scarica tagliando RCA" placement="right">
                                <i class="fas fa-file-download"></i>
                            </button>

                            <button type="button" class="btn btn-outline-success" (click)="endTravel(travel)"
                                    tooltip="Riconsegna veicolo e termina il viaggio" placement="right">
                                <i class="fas fa-calendar-times"></i>
                            </button>

                        </ng-container>

                        <!-- VIAGGIO TERMINATO -->
                        <ng-container *ngIf="travel.travelEnded()">
                            <button type="button" class="btn btn-outline-alert"
                                    (click)="viewRefillsForTravel(travel)"
                                    tooltip="Vedi i rifornimenti" placement="right">
                                <i class="fas fa-gas-pump"></i>
                            </button>
                        </ng-container>

                    </ng-container>


                    <!-- AMMINISTRATORE -->
                    <ng-container  *ngIf="authService.is_admin() && travel.type===1">
                        <ng-container *ngIf="
                          travel.travelApproved() &&
                          !travel.travelEnded()" >
                            <button type="button" class="btn btn-outline-secondary"
                                    (click)="forceCloseTravel(travel)"
                                    tooltip="Interrompi il viaggio" placement="right">
                                <span class="oi oi-x"></span>
                            </button>
                        </ng-container>
                        <ng-container *ngIf="
                          travel.travelApproved() &&
                          !travel.travelEnded() &&
                          !travel.travelStarted()" >

                            <button type="button" class="btn btn-outline-secondary"
                                    (click)="changeAssignedVehicle(travel)"
                                    tooltip="Cambia veicolo assegnato" placement="right">
                                <span class="fas fa-car"></span>
                            </button>

                        </ng-container>

                        <ng-container *ngIf="
                          travel.travelRequested() &&
                          !travel.travelApproved() &&
                          travel.travelPending()">
                            <button type="button" class="btn btn-outline-success" (click)="approveTravel(travel)"
                                    tooltip="Approva il viaggio" placement="right">
                                <span class="oi oi-check"></span>
                            </button>
                            <button type="button" class="btn btn-outline-danger" (click)="declineTravel(travel)"
                                    tooltip="Rifiuta il viaggio" placement="right">
                                <span class="oi oi-ban"></span>
                            </button>
                        </ng-container>

                        <!-- SE CREATORE DEL VIAGGIO È ANCHE L'ADMIN -->
                        <ng-container  *ngIf="travel.user.id == authService.getAuthenticatedUser().id">

                            <!-- COMPILA FOGLIO DI MARCIA-->
                            <ng-container *ngIf="travel.travelApproved() &&
                                !travel.travelStarted() && !travel.travelEnded()">
                                <button type="button" class="btn btn-outline-classic" (click)="compileWarrant(travel)"
                                        tooltip="Compila il foglio di marcia" placement="right">
                                    <span class="oi oi-book"></span>
                                </button>
                            </ng-container>
                            <!-- VIAGGIO IN CORSO -->
                            <ng-container *ngIf="travel.travelApproved() &&
                                travel.travelStarted() && !travel.travelEnded()">

                                <button type="button" class="btn btn-outline-alert" (click)="insertRefills(travel)"
                                        tooltip="Inserisci rifornimento" placement="right">
                                    <i class="fas fa-gas-pump"></i>
                                </button>

                                <button type="button" class="btn btn-outline-alert" (click)="getVehicleDocument(travel)"
                                        tooltip="Scarica tagliando RCA" placement="right">
                                    <i class="fas fa-file-download"></i>
                                </button>

                                <!-- <button type="button" class="btn btn-outline-alert" (click)="getCartaCircolazione(travel)"
                                        [tooltip]="disableCartaCircolazioneMap[travel.vehicle.plate] ? '' : 'Scarica carta di circolazione'" placement="right" [disabled]="disableCartaCircolazioneMap[travel.vehicle.plate]">
                                    <i class="fas fa-file-pdf"></i>
                                </button> -->

                                <button type="button" class="btn btn-outline-success" (click)="endTravel(travel)"
                                        tooltip="Riconsegna veicolo e termina il viaggio" placement="right">
                                    <i class="fas fa-calendar-times"></i>
                                </button>

                            </ng-container>

                        </ng-container>
                        <!-- VIAGGIO TERMINATO -->
                        <ng-container *ngIf="travel.travelEnded()">
                            <button type="button" class="btn btn-outline-alert" (click)="viewRefillsForTravel(travel)"
                                    tooltip="Vedi i rifornimenti" placement="right">
                                <i class="fas fa-gas-pump"></i>
                            </button>
                        </ng-container>

                    </ng-container>


                </div>

            </div>

        </ul>

        <app-assign-car-to-user (vehicleAssigned)="vehicleAssigned()"></app-assign-car-to-user>
        <app-change-car-to-user (vehicleAssigned)="vehicleAssigned()"></app-change-car-to-user>
        <app-compile-warrant (travelStarted)="reloadList()"></app-compile-warrant>
        <app-insert-refills (refillsCompleted)="reloadList()"></app-insert-refills>
    <!-- </app-pull-to-refresh> -->
</div>
